document.addEventListener('DOMContentLoaded', function() {
    $(document).on("swell:setup", function(){
        var customerDetails = swellAPI.getCustomerDetails();

        var dollarTotalTxt = 0;

        if (customerDetails.pointsBalance > 400) {
            dollarTotalTxt = 60;
        }
        else {
            var dollarTotal = Math.floor((customerDetails.pointsBalance / 100) * 15);
            var dollarTotalTxt = dollarTotal.toString().slice(0, -1) + '0';
        }

        $('#point-rewards-available').text(customerDetails.pointsBalance);
        $('#dollar-rewards-available').text('$' + dollarTotalTxt);
        $('#referral-code').text(customerDetails.referralCode);
        $('#my-referral-link').text(customerDetails.referralLink).attr('href', customerDetails.referralLink);

    });
});